import moment from 'moment-timezone';
import _ from 'lodash';
import 'moment/locale/ar';
import 'moment/locale/zh-cn';
import 'moment/locale/fr';
import 'moment/locale/de';
import 'moment/locale/it';
import 'moment/locale/pt';
import 'moment/locale/ru';
import 'moment/locale/es';
import 'moment/locale/fa';

const getTranslatedTimeZoneName = (tz, lang) => {
  // 1️⃣ Try Intl.DisplayNames (if supported)
  try {
    if (
      typeof Intl !== 'undefined' &&
      typeof Intl.DisplayNames === 'function'
    ) {
      const dn = new Intl.DisplayNames([lang], { type: 'timeZone' });
      const name = dn.of(tz);
      if (name) return name;
    }
  } catch {
    // silently fall through
  }

  // 2️⃣ Fallback: Intl.DateTimeFormat
  try {
    const parts = new Intl.DateTimeFormat(lang, {
      timeZone: tz,
      timeZoneName: 'long',
    }).formatToParts(new Date());

    const tzName = parts.find(p => p.type === 'timeZoneName');
    if (tzName?.value) return tzName.value;
  } catch {
    // silently fall through
  }

  // 3️⃣ Final fallback
  return tz.replace(/_/g, ' ');
};

export const formatTz = (tz, lang) => {
  moment.locale(lang);

  const offset = moment.tz(tz).format('Z');
  const translatedName = getTranslatedTimeZoneName(tz, lang);

  return {
    name: `(GMT ${offset}) ${translatedName}`,
    value: tz,
  };
};

export const getTimeZones = lang =>
  _.sortBy(
    moment.tz.names().map(tz => formatTz(tz, lang)),
    [tz => moment.tz(tz.value).format('Z')],
  );
